import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { LOCAL__collection_set_current } from '@/state/collection/entity/local_collection_set_current';
import { local_collection_set_special_collections_by_workspace_id } from '@/state/collection/entity/local_collection_set_special_collections_by_workspace_id';
import { local_collection_special_info_set_current } from '@/state/collection/special/local_collection_special_info_set_current';
import { local_ml_asset_reservations_update_active } from '@/state/diffusion_models_ud/local_ml_asset_reservations_update_active';
import { LOCAL__generation_set_current } from '@/state/generation/LOCAL__generation_set_current';
import { local_search_set_current } from '@/state/search/local_search_set_current';
import { store } from '@/state/store';
import { REMOTE__user_settings_update } from '@/state/user/settings/REMOTE__user_settings_update';
import { local_workspace_child_entity_set_current_viewed } from '@/state/workspace/child_entity/local_workspace_child_entity_set_current_viewed';
import { remote_workspace_child_entity_update_viewer_status } from '@/state/workspace/child_entity/remote_workspace_child_entity_update_viewer_status';
import { LOCAL__workspace__set_current } from '@/state/workspace/entity/LOCAL__workspace__set_current';
import { assert_array_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__workspace_entity_viewer } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_viewer';
import { DTOWorkspaceChildEntityViewer } from '@shared/dto/+workspace/workspace_entity/dto_workspace_child_entity_viewer';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { UTILS__graph_ui } from './UTILS__graph_ui';

export async function try_set_default_workspace() {
  let slice_workspace = store.getState().slice_workspace;
  let slice_settings = store.getState().slice_user;

  let workspace_default = slice_workspace.workspaces_map.get(slice_settings.user_settings.default_workspace_id);

  if (workspace_default) {
    set_current_workspace(workspace_default._id);
  } else {
    let workspaces_array = Array.from(slice_workspace.workspaces_map.values());

    let workspace_personal = workspaces_array.find_or_assert(item => item.is_personal);

    let { user_settings } = slice_settings;

    if (!user_settings.is_stub()) {
      await store.dispatch(REMOTE__user_settings_update(user_settings.clone({ default_workspace_id: workspace_personal._id })));
    }

    set_current_workspace(workspace_personal._id);
  }
}

export function set_current_workspace(workspace_id: string) {
  let user_id = store.getState().slice_user.user_id;
  let workspace_current = store.getState().slice_workspace.workspace_current;

  if (workspace_current._id == workspace_id) return;

  /*
   * DIFFUSION MODELS
   */

  store.dispatch(local_ml_asset_reservations_update_active(workspace_id));

  /*
   * COLLECTIONS
   */
  let slice_collections = store.getState().slice_collections;

  let collections = Array.from(slice_collections.collections_map.values())
    .filter(item => item.workspace_id == workspace_id)
    .sort(DTO__database_entity.sort_by_created_at_newest_first);

  if (slice_collections.collection_current.workspace_id == workspace_id) {
    //do nothing
  } else if (collections.is_empty()) {
    store.dispatch(LOCAL__collection_set_current(''));
  } else {
    let collection = collections.find(item => item.type == ENUM__workspace_entity.COLLECTION_FAVORITES);

    if (!collection) collection = collections[0];

    store.dispatch(LOCAL__collection_set_current(collection._id));
  }

  store.dispatch(local_collection_set_special_collections_by_workspace_id(workspace_id));

  store.dispatch(local_collection_special_info_set_current(workspace_id));

  /*
   * USER TASKS
   */
  let slice_generation = store.getState().slice_generation;

  let generations = Array.from(slice_generation.generations_map.values())
    .filter(item => item.workspace_id == workspace_id)
    .sort(DTO__database_entity.sort_by_updated_at_newest_first);

  if (slice_generation.generation_current.workspace_id == workspace_id) {
    //do nothing
  } else if (generations.is_empty()) {
    store.dispatch(LOCAL__generation_set_current(''));
  } else {
    assert_array_not_empty(generations, { context: 'generation' });

    let most_recent_generation = generations[0];

    store.dispatch(LOCAL__generation_set_current(most_recent_generation._id));
  }

  /*
   * SEARCH
   */
  let slice_search = store.getState().slice_search;

  let searches = Array.from(slice_search.search_history_map.values())
    .filter(item => item.workspace_id == workspace_id)
    .sort(DTO__database_entity.sort_by_created_at_newest_first);

  if (slice_search.search_current.workspace_id == workspace_id) {
    //do nothing
  } else if (searches.is_empty()) {
    store.dispatch(local_search_set_current(''));
  } else {
    let search = searches[0];
    store.dispatch(local_search_set_current(search._id));
  }

  store.dispatch(LOCAL__workspace__set_current({ user_id, workspace_id }));
}

export function set_collection_current(id: string) {
  let slice_collections = store.getState().slice_collections;
  let collections_map = slice_collections.collections_map;

  let collection_current_new = id ? collections_map.get_or_assert(id, { context: 'collection' }) : DTO__collection.CREATE_STUB();

  if (collection_current_new._id == slice_collections.collection_current._id) return collection_current_new;

  store.dispatch(LOCAL__collection_set_current(id));

  return store.getState().slice_collections.collection_current;
}

export async function set_current_generation(id: string) {
  let slice_generation = store.getState().slice_generation;
  let generations_map = slice_generation.generations_map;

  //todo: review this case and use enumstringidempty
  if (!id) debugger;

  //todo: why we dont use enumstringid here but
  let generation_current_new = id ? generations_map.get_or_assert(id) : DTO__generation.CREATE_STUB();

  if (generation_current_new._id == slice_generation.generation_current._id) return generation_current_new;

  store.dispatch(LOCAL__generation_set_current(id));

  if (!generation_current_new.is_stub()) {
    let { invocation_grid2d_view } = generation_current_new.tool.graph;

    UTILS__graph_ui.node__select(invocation_grid2d_view.meta.node_id);
  }

  await try_update_viewed_entity(generation_current_new);

  return store.getState().slice_generation.generation_current;
}

export async function set_current_search(id: string) {
  let slice_search = store.getState().slice_search;
  let search_history_map = slice_search.search_history_map;

  let search_current_new = id ? search_history_map.get_or_assert(id, { context: 'search' }) : DTOSearchSettings.CREATE_STUB();

  if (search_current_new._id == slice_search.search_current._id) return search_current_new;

  store.dispatch(local_search_set_current(id));

  await try_update_viewed_entity(search_current_new);

  return store.getState().slice_search.search_current;
}

export async function try_update_viewed_entity(entity: DTO__entity_with_grid2d) {
  let { current_viewed_entity } = store.getState().slice_workspace;

  if (current_viewed_entity._id == entity._id && current_viewed_entity.type == entity.type) return;

  let updates = [];

  if (!current_viewed_entity.is_stub()) {
    let update_leave = new DTOWorkspaceChildEntityViewer();
    update_leave.workspace_id = current_viewed_entity.workspace_id;
    update_leave.entity_id = current_viewed_entity._id;
    update_leave.entity_type = current_viewed_entity.type;
    update_leave.is_view = false;

    updates.push(update_leave);
  }

  if (!entity.is_stub()) {
    let update_visit = new DTOWorkspaceChildEntityViewer();
    update_visit.workspace_id = entity.workspace_id;
    update_visit.entity_id = entity._id;
    update_visit.entity_type = entity.type;
    update_visit.is_view = true;

    updates.push(update_visit);
  }

  store.dispatch(local_workspace_child_entity_set_current_viewed(entity));

  if (updates.length > 0) {
    await store.dispatch(remote_workspace_child_entity_update_viewer_status(updates));
  }
}

export async function on_user_leave_from_entity(entity_id: string, entity_type: string) {
  let { current_viewed_entity } = store.getState().slice_workspace;

  if (current_viewed_entity.is_stub()) return;
  if (current_viewed_entity._id != entity_id || current_viewed_entity.type != entity_type) return;

  let update_leave = new DTOWorkspaceChildEntityViewer();
  update_leave.workspace_id = current_viewed_entity.workspace_id;
  update_leave.entity_id = current_viewed_entity._id;
  update_leave.entity_type = current_viewed_entity.type;
  update_leave.is_view = false;

  store.dispatch(local_workspace_child_entity_set_current_viewed(DTO__workspace_child_enity.CREATE_STUB()));

  await store.dispatch(remote_workspace_child_entity_update_viewer_status([update_leave]));
}

export function get_entity_viewer_color_as_workspace_user(viewer: DTOWorkspaceChildEntityViewer, workspace_viewers_ids: string[]) {
  if (viewer.viewer_type != ENUM__workspace_entity_viewer.WORKSPACE_USER) return CONSTANTS__client.USER_NEUTRAL_COLOR;

  return workspace_viewers_ids.indexOf(viewer.user_id).toString();
}
